import { Link } from 'react-router-dom';

const footerLinks = {
  热门分类: [
    { label: '才艺表演', path: '/categories?tab=talent' },
    { label: '游戏陪玩', path: '/categories?tab=gaming' },
    { label: '生活分享', path: '/categories?tab=lifestyle' },
    { label: '聊天互动', path: '/categories?tab=chat' },
  ],
  推荐内容: [
    { label: '热门主播排行', path: '/articles/7' },
    { label: '平台推荐评测', path: '/articles/1' },
    { label: '直播互动指南', path: '/articles/4' },
    { label: '免费观看攻略', path: '/articles/6' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about' },
    { label: '用户协议', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-live-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading font-bold text-xl text-background-50">
                  美女直播精选
                </span>
              </Link>
              <p className="text-background-400 text-sm leading-relaxed mt-3">
                汇聚高颜值主播的直播平台推荐，为您精选最优质的直播内容。才艺表演、游戏陪玩、生活分享，多元内容任您选择。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="font-heading font-semibold text-background-50 text-base mb-4">
                  {title}
                </h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-sm">
            &copy; {new Date().getFullYear()} 美女直播平台精选 · 版权所有
          </p>
          <div className="flex items-center gap-4 text-background-500 text-sm">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">Cookie 设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}